import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/order-confirmations')({
  component: OrderConfirmationsLayout,
});

function OrderConfirmationsLayout() {
  return <Outlet />;
}
